<template>
  <van-popup v-model="show" round position="bottom">
   <van-datetime-picker
    v-model="datetime"
    :type="type"
    title="选择时间"
    :min-date="start"
    :max-date="end"
    @confirm="onConfirm"
  />
  </van-popup>
</template>

<script>
import { DatetimePicker } from 'vant';
export default {
  name: 'DateTimePicker',
  components: {
    [DatetimePicker.name]: DatetimePicker
  },
  props: {
    type: {
      type: String,
      default: 'date'
    },
    value: {
      type: String | Object
    },
    start: {
      type: Date
    },
    end: {
      type: Date
    }
  },
  
  model: {
    prop: 'value',
    event: 'update'
  },
  data() {
    return {
      show: false,
      datetime: null
    }
  },
  methods: {
    open() {
      const dateTimeValue = this.$utils.checkType(this.value) === 'string' ? new Date(this.value) : this.value
      this.datetime = this.value ? dateTimeValue : new Date()
      this.show = true
    },
    onConfirm() {
      this.$emit('update', this.datetime)
      this.show = false
    }
  }
}
</script>

<style lang="less" scoped>
  .mobile-field-style {
    border: 1px solid #DCDFE6;
    border-radius: 4px;
  }
  .search-wrapper {
    padding: 10px 16px 0;
  }
</style>